// extracted by mini-css-extract-plugin
export var text = "_bj-0";